<template>
  <div class="content">
    <div class="row">
      <div class="col-md-10 flex-container-top">
        <h2 class="text-eveer">Events List</h2>
        <base-button v-if="role == 'Admin'" type="primary" round icon class="top-button"
          @click="$router.push('add?id=-1')">
          <i class="fa fa-plus"></i>
        </base-button>
        <base-button v-if="role == 'Admin'" type="primary" class="top-button pull-right"
          @click="displayOlderEvents()">
          View Older Events
        </base-button>
      </div>
      <div class="col-md-2 flex-container-top">
        <base-button v-if="role == 'Admin'" type="primary" class="top-button pull-right" @click="$router.push('list')">
          Grid View
        </base-button>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">Events List</h4>
          <div>
            <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
              <el-select class="select-primary mb-3 pagination-select" v-model="pagination.perPage"
                placeholder="Per page">
                <el-option class="select-primary" v-for="item in pagination.perPageOptions" :key="item" :label="item"
                  :value="item">
                </el-option>
              </el-select>
              <base-input>
                <el-input type="search" class="mb-3 search-input" clearable prefix-icon="el-icon-search"
                  placeholder="Search records" v-model="searchQuery" aria-controls="datatables">
                </el-input>
              </base-input>
            </div>
            <el-table :data="queriedData" style="font-size: 13px">
              <el-table-column :min-width="100" align="left" label="Picture">
                <div slot-scope="props">
                  <div style="display: flex">
                    <div>
                      <div>
                        <img class="rest-img" :src="props.row.image" alt="..." style="height: 100px" />
                      </div>
                    </div>
                  </div>
                </div>
              </el-table-column>
              <el-table-column :min-width="200" align="left" label="Event Name">
                <div slot-scope="props">
                  <div>
                    <div>
                      <a href="javascript:void(0)" @click="$router.push('bookings?event_id=' + props.row._id)"
                        title="Click to open event bookings">{{ props.row.event_name }}</a>
                    </div>
                  </div>
                </div>
              </el-table-column>
              <el-table-column :min-width="200" align="left" label="Price">
                <div slot-scope="props">
                  <div v-if="!props.row.is_dynamic_price">
                    {{ props.row.early_price }} Early / {{ props.row.regular_price }} Regular
                  </div>
                  <div v-else>
                    {{ props.row.original_price }} Price / {{ props.row.min_price }} Min / {{ props.row.max_price }} Max
                  </div>
                </div>
              </el-table-column>
              <el-table-column :min-width="200" align="left" label="Schedule">
                <div slot-scope="props">
                  <div>
                    <div>{{ props.row.date }} {{ props.row.end_date ? ` / ${props.row.end_date}` : '' }}</div>
                    <div>{{ props.row.start_time }} - {{ props.row.end_time }}</div>
                  </div>
                </div>
              </el-table-column>
              <el-table-column :min-width="200" align="left" label="Booked/Total" >
                <div slot-scope="props">
                  <div>
                    <div> {{ props.row.booked }} Booked /
                      
                      
                      <span v-if="!props.row.is_unlimited_bookings">{{ props.row.total_slots }} </span>
                      
                       <span v-if="props.row.is_unlimited_bookings">Unlimited </span>
                      
                      Total
                    
                    
                    </div>
                  </div>
                </div>
              </el-table-column>
              <el-table-column :min-width="200" align="left" label="Location">
                <div slot-scope="props">
                  <div>
                    <div>{{ props.row.address }}, City - {{ props.row.city }}</div>
                  </div>
                </div>
              </el-table-column>
              <el-table-column :min-width="200" align="left" label="Description">
                <div slot-scope="props">
                  <div>
                    <div>{{ props.row.description }}</div>
                  </div>
                </div>
              </el-table-column>
              <el-table-column :min-width="200" align="left" label="Control">
                <div slot-scope="props">
                  <i v-if="role == 'Admin'" class="fa fa-user-plus icon-padding"
                    @click="$router.push('organizer?event_id=' + props.row._id)" title="Assign Organizer"
                    style="color: white; cursor: pointer"> </i>
                  <i v-if="role == 'Admin'" class="fa fa-edit text-warning icon-padding"
                    @click="$router.push('edit?id=' + props.row._id)" title="Edit Event" style="cursor: pointer"> </i>
                  <i v-if="role == 'Admin'" class="fa fa-trash-alt text-danger icon-padding"
                    @click="deleteEvent(props.row._id)" title="Delete This Event" style="cursor: pointer">
                  </i>
                  <i v-if="role == 'Admin' && props.row.event_recurrence_id" class="fa fa-trash text-danger icon-padding"
                    @click="deleteRecursiveEvent(props.row._id)" title="Delete Recurrence"
                    style="color: red; cursor: pointer"> Delete Recurrence
                  </i>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <base-pagination class="pagination-no-border" v-model="pagination.currentPage" :per-page="pagination.perPage"
              :total="total">
            </base-pagination>
          </div>
        </card>
      </div>
    </div>
    <div class="row loader-pos">
      <div class="sk-chase" v-if="loading">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>
      <div class="no-data-message" v-if="noDataMessage">
        <div>There are no records found</div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "src/components";
import Fuse from "fuse.js";
import swal from "sweetalert2";
import { Modal, BaseAlert } from "src/components";
export default {
  components: {
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal,
    BaseAlert,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      role: window.localStorage.getItem("role"),
      noDataMessage: "",
      loading: false,
      modals_classic: false,
      actions: [],
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [50, 100, 1000],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["name", "email", "age"],
      tableColumns: [
        {
          prop: "name",
          label: "Name",
          minWidth: 200,
        },
        {
          prop: "email",
          label: "Email",
          minWidth: 250,
        },
        {
          prop: "age",
          label: "Age",
          minWidth: 100,
        },
      ],
      tableData: [],
      tableDatas: [],
      searchedData: [],
      fuseSearch: null,
      currentOrder: {},
      isOlderEvents: false
    };
  },
  async mounted() {
    // this.isOlderEvents = false;
    this.loading = true;
    let test = await this.$apiService.getCall("event/events?displayAll=1");
    if (test.apidata.Code == 'EVE002') {
      this.$apiService.notify("Somthing went wrong to get event data. Please, Refresh the page.");
    }
    this.role = window.localStorage.getItem("role");
    var role = this.role;
    var userid = window.localStorage.getItem("userid");
    if (role == "Admin") {
      this.tableDatas = test.apidata.Data || [];
      this.tableData = test.apidata.Data || [];
    } else {
      this.tableDatas = test.apidata.Data || [];
      var toDisplay = [];
      for (var i = 0; i < tableDatas.length; i++) {
        if (tableDatas[i].organizer == userid) {
          toDisplay.push(tableDatas[i]);
        }
      }
      this.tableData = toDisplay;
    }

    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["address", "date", "regular_price", "event_name"],
      threshold: 0.3,
    });

    this.tableData.sort((a, b) => (this.compare(a.date, b.date) || this.compare(a.start_time, b.start_time)));
    this.loading = false;
    if ((this.tableData || []).length == 0) {
      this.noDataMessage = true;
    }
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      console.log("262",value);
      console.log("263",this.searchQuery);
      if (this.searchQuery !== "") {
        result = this.fuseSearch.search(this.searchQuery);
        console.log("166",result);
        result = result.map(a => a.item);
      }
      this.searchedData = result;
    },
  },
  methods: {
    async compare(a, b) {
      if (a > b) return +1;
      if (a < b) return -1;
      return 0;
    },
    setTableRows(events) {
      this.role = window.localStorage.getItem("role");
      var role = this.role;
      var userid = window.localStorage.getItem("userid");
      const rows = Array.isArray(events) ? events : [];

      this.tableDatas = rows;
      if (role == "Admin") {
        this.tableData = rows;
      } else {
        this.tableData = rows.filter((event) => event.organizer == userid);
      }

      this.fuseSearch = new Fuse(this.tableData, {
        keys: ["address", "date", "regular_price", "event_name"],
        threshold: 0.3,
      });

      this.tableData.sort((a, b) => (this.compare(a.date, b.date) || this.compare(a.start_time, b.start_time)));
      if (this.searchQuery !== "") {
        let result = this.fuseSearch.search(this.searchQuery);
        this.searchedData = result.map(a => a.item);
      } else {
        this.searchedData = [];
      }
      this.noDataMessage = (this.tableData || []).length == 0;
    },
    async refreshEventsFromV1() {
      const maxPerPage = Math.max.apply(null, this.pagination.perPageOptions);
      const olderEventsParam = this.isOlderEvents ? "&displayOlderEvents=1" : "";
      const response = await this.$apiService.getCall(
        `event/events-v1?page=1&limit=${maxPerPage}${olderEventsParam}`
      );

      if (
        response.isError ||
        !response.apidata ||
        response.apidata.Code == "EVE002"
      ) {
        this.$apiService.notify(
          "Somthing went wrong to get event data. Please, Refresh the page."
        );
        return false;
      }

      const data = response.apidata.Data;
      const events = data && data.events ? data.events : data;
      this.setTableRows(events || []);
      return true;
    },
    async deleteRecursiveEvent(id) {
      let confirmed = confirm("Are you sure you want to delete all recurring events associated with this event?");
      if (confirmed === true) {
        this.loading = true;
        const del_event_status = await this.$apiService.getCall("event/recursive-event-delete/" + id)
        const message =
          del_event_status &&
          del_event_status.apidata &&
          del_event_status.apidata.Message;
        if (del_event_status.isError || message !== "Success") {
          this.loading = false;
          this.$apiService.notify(message || "Unable to delete recurring events.");
        } else {
          await this.refreshEventsFromV1();
          this.loading = false;
          this.$apiService.notify("Recurring events have been deleted.", { duration: 2000 });
        }
      }
    },
    async deleteEvent(id) {
      let confirmed = confirm("Are you sure you want to delete this event? ");
      if (confirmed === true) {
        this.loading = true;
        const del_event = await this.$apiService.getCall("event/event-delete/" + id)
        const message =
          del_event &&
          del_event.apidata &&
          del_event.apidata.Message;
        if (del_event.isError || message !== "Success") {
          this.loading = false;
          this.$apiService.notify(message || "Unable to delete event.");
        } else {
          await this.refreshEventsFromV1();
          this.loading = false;
          this.$apiService.notify("Events has been deleted.", { duration: 2000 });
        }
      }
    },
    async displayOlderEvents() {
      if (!this.isOlderEvents) {
        this.tableData = [];
        this.loading = true;
        let test = await this.$apiService.getCall("event/events?displayOlderEvents=1");
        if (test.apidata.Code == 'EVE002') {
          this.$apiService.notify("Somthing went wrong to get event data. Please, Refresh the page.");
        }
        this.role = window.localStorage.getItem("role");
        var role = this.role;
        var userid = window.localStorage.getItem("userid");
        if (role == "Admin") {
          this.tableDatas = test.apidata.Data || [];
          this.tableData = test.apidata.Data || [];
        } else {
          this.tableDatas = test.apidata.Data || [];
          var toDisplay = [];
          for (var i = 0; i < tableDatas.length; i++) {
            if (tableDatas[i].organizer == userid) {
              toDisplay.push(tableDatas[i]);
            }
          }
          this.tableData = toDisplay;
        }

        // Fuse search initialization.
        this.fuseSearch = new Fuse(this.tableData, {
          keys: ["address", "date", "regular_price", "event_name"],
          threshold: 0.3,
        });

        this.tableData.sort((a, b) => (this.compare(a.date, b.date) || this.compare(a.start_time, b.start_time)));
        this.isOlderEvents = true;
        this.loading = false;
      } else {
        this.$apiService.notify("Already older events displayed.");
      }
    }
  },
};
</script>
<style>
.pagination-select,
.search-input {
  width: 200px;
}

.swal2-icon-content {
  font-size: inherit !important;
}

.rest-img {
  width: 100%;
  height: 150px;
}

.icon-padding {
  padding: 10px;
}
</style>
